import React from "react";

const Card = ({
  children,
  className = "",
  fullHeight = false,
}: {
  children: React.ReactNode;
  className?: string;
  fullHeight?: boolean;
}) => {
  return (
    <div
      className={`bg-white rounded-lg shadow-sm flex flex-col px-6 sm:px-8 py-6 sm:py-8 ${fullHeight ? "min-h-[calc(100vh-82px-4rem)]" : ""} ${className}`}
    >
      {children}
    </div>
  );
};

export default Card;
